
import Vue from 'vue';
import Component from 'vue-class-component';

import Navbar from './Navbar.vue';
import Me from './Me.vue';
import EmploymentView from './EmploymentView.vue';

@Component({
    components: {
        Navbar,
        EmploymentView,
        Me
    }
})
export default class Home extends Vue {
}
